$(document).on("click",".cal-input-item",function() {
  var id = $(this).data('id');
  var color = $('[name="Farbe"]:checked').val();
  
  $('.thumbnail-list__item img[alt="'+color+" - "+id+'"]').parent().click();
});

function showVal(newVal){
    document.getElementById("rangeSuccess").innerHTML=newVal;
}

$(document).on("keyup change",".custom-filter-input input, .custom-filter-input input[type='range']",function() {
  var bar = parseInt($('.nToleranz').val(), 10); // Ensure bar is an integer

var value_1 = parseInt($('.filter-input-length').val(), 10); // Ensure values are integers
var value_2 = parseInt($('.filter-input-width').val(), 10);
var value_3 = parseInt($('.filter-input-height').val(), 10);
var has_product = false;

function calculateSimilarity(value, target) {
    // Calculate the absolute difference
    var difference = Math.abs(value - target);
    
    // Return the similarity based on the distance to the bar
    // If difference is less than or equal to bar, we consider it similar
    return difference <= (bar*2) ? 0 : difference; // Return 0 for similar and the distance otherwise
}

if (value_1 || value_2 || value_3) {
    $('.check_collection_recommendation .grid__item').each(function () {
        var length = parseInt($(this).data('length'), 10); // Get integer values
        var width = parseInt($(this).data('width'), 10);
        var height = parseInt($(this).data('height'), 10);
        var showProduct = false;

        // If all three values are filled, check similarity for all
        if (!isNaN(value_1) && !isNaN(value_2) && !isNaN(value_3)) {
            showProduct = calculateSimilarity(value_1, length) === 0 &&
                          calculateSimilarity(value_2, width) === 0 &&
                          calculateSimilarity(value_3, height) === 0;
        }
        // If value_1 and value_2 are filled, check similarity for those
        else if (!isNaN(value_1) && !isNaN(value_2)) {
            showProduct = calculateSimilarity(value_1, length) === 0 &&
                          calculateSimilarity(value_2, width) === 0;
        }
        // If value_2 and value_3 are filled, check similarity for those
        else if (!isNaN(value_2) && !isNaN(value_3)) {
            showProduct = calculateSimilarity(value_2, width) === 0 &&
                          calculateSimilarity(value_3, height) === 0;
        }
        // If value_1 and value_3 are filled, check similarity for those
        else if (!isNaN(value_1) && !isNaN(value_3)) {
            showProduct = calculateSimilarity(value_1, length) === 0 &&
                          calculateSimilarity(value_3, height) === 0;
        }
        // If only one value is filled, calculate its similarity
        else if (!isNaN(value_1)) {
            showProduct = calculateSimilarity(value_1, length) === 0;
        } else if (!isNaN(value_2)) {
            showProduct = calculateSimilarity(value_2, width) === 0;
        } else if (!isNaN(value_3)) {
            showProduct = calculateSimilarity(value_3, height) === 0;
        }
        if (showProduct) {
            $(this).show();
            has_product = true;
        } else {
            $(this).hide();
        }
    });
} else {
    $('.check_collection_recommendation .grid__item').show();
    has_product = true;
}

// if (!has_product) {
//     $('.collection_recommendation').removeClass('hide');
// } else {
//     $('.collection_recommendation').addClass('hide');
// }
$('.collection_recommendation').removeClass('hide');
$('.collection_recommendation').show();
});

$(document).on("click",".header__inline-menu-custom-filter .custom-filter-button",function() {
  var has_value = false;
  var length = '';
  var width = '';
  var height = '';
  
  if($('.header__inline-menu-custom-filter .custom-filter-input .filter-input-length').val() != ''){
    has_value = true;
    length = $('.header__inline-menu-custom-filter .custom-filter-input .filter-input-length').val();
  }
  if($('.header__inline-menu-custom-filter .custom-filter-input .filter-input-width').val() != ''){
    has_value = true
    width = $('.header__inline-menu-custom-filter .custom-filter-input .filter-input-width').val();
  }
  if($('.header__inline-menu-custom-filter .custom-filter-input .filter-input-height').val() != ''){
    has_value = true
    height = $('.header__inline-menu-custom-filter .custom-filter-input .filter-input-height').val();
  }

  if(has_value){
    localStorage.setItem("length", length);
    localStorage.setItem("width", width);
    localStorage.setItem("height", height);
    localStorage.setItem("percentage", "10");

    window.location.href = "collections/anhangerplanen";
  }
});

$(document).on("click",".header__inline-menu-custom-filter-mobile .custom-filter-button",function() {
  var has_value = false;
  var length = '';
  var width = '';
  var height = '';
  var percentage = '';
  
  if($('.header__inline-menu-custom-filter-mobile .custom-filter-input .filter-input-length').val() != ''){
    has_value = true;
    length = $('.header__inline-menu-custom-filter-mobile .custom-filter-input .filter-input-length').val();
  }
  if($('.header__inline-menu-custom-filter-mobile .custom-filter-input .filter-input-width').val() != ''){
    has_value = true
    width = $('.header__inline-menu-custom-filter-mobile .custom-filter-input .filter-input-width').val();
  }
  if($('.header__inline-menu-custom-filter-mobile .custom-filter-input .filter-input-height').val() != ''){
    has_value = true
    height = $('.header__inline-menu-custom-filter-mobile .custom-filter-input .filter-input-height').val();
  }
  percentage = $('.header__inline-menu-custom-filter-mobile .custom-filter-input .nToleranz').val()

  if(has_value){
    localStorage.setItem("length", length);
    localStorage.setItem("width", width);
    localStorage.setItem("height", height);
    localStorage.setItem("percentage", percentage);

    window.location.href = "collections/anhangerplanen";
  }
});

function set_values() {
  if($('.collection_custom_filtering').length > 0){
    var length = localStorage.getItem("length");
    var width = localStorage.getItem("width");
    var height = localStorage.getItem("height");
    var percentage = localStorage.getItem("percentage");

    if(length != null || width != null || height != null){
      $('.collection_custom_filtering .filter-input-length').val(length);
      $('.collection_custom_filtering .filter-input-width').val(width);
      $('.collection_custom_filtering .filter-input-height').val(height);
      $('.collection_custom_filtering .nToleranz').val(percentage);
      $('.collection_custom_filtering #rangeSuccess').text(percentage);

      $('.collection_custom_filtering .filter-input-length').keyup();
      localStorage.removeItem("length");
      localStorage.removeItem("width");
      localStorage.removeItem("height");
      localStorage.removeItem("percentage");
    }
  }
}

set_values();

function restoreNativeHeaderMenuIfGloboMissing() {
  if (document.querySelector(".gm-menu")) {
    return;
  }

  document.documentElement.classList.remove("globo-menu-loading");
  document.body.classList.remove("gm-menu-installed");

  document.querySelectorAll("nav.header__inline-menu > ul.list-menu.list-menu--inline").forEach(function (menu) {
    menu.style.setProperty("display", "flex", "important");
    menu.style.setProperty("visibility", "visible", "important");
    menu.style.setProperty("opacity", "1", "important");
    menu.style.setProperty("height", "auto", "important");
  });
}

restoreNativeHeaderMenuIfGloboMissing();
document.addEventListener("DOMContentLoaded", restoreNativeHeaderMenuIfGloboMissing);
setTimeout(restoreNativeHeaderMenuIfGloboMissing, 800);
setTimeout(restoreNativeHeaderMenuIfGloboMissing, 2500);